"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const listStringify_1 = __importDefault(require("../lib/listStringify"));
const registries_1 = require("../registries");
registries_1.functionRegistry.set('R', (context, args) => {
    let [l, r, step = 1] = args.map(parseFloat);
    let a = [];
    for (let i = l; i < r; i += step) {
        a.push(i);
    }
    return listStringify_1.default(a);
});
